import React, {useState} from 'react';
import MediaQuery from "react-responsive";
import {JobbizLogo, CloseModal, MenuBar} from "assets/icons";
import NavbarMobile from "./NavbarComponents/NavbarMobile/NavbarMobile";
import NavbarDesktop from "./NavbarComponents/NavbarDesktop/NavbarDesktop";
import {useLocation} from "react-router-dom";


const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const handleMenu = () => {
        setMenuOpen(!menuOpen);
    };
    const route =useLocation()
    const {pathname}=route
    const path = pathname.split('/')
    const page=path[1]
    const PAGE ={
        'dashboard':'Tableau de bord',
        'identity_validation': 'Validation d\'identité',
        'timeSheet': 'Relevé d\'heures',
        'company': 'Entreprises',
        'missions': 'Missions',
        'profil':'Profil',
        'searchMission':'Recherche de mission',
        'documents':'Mes documents',
        'mission':'Mes missions',
        'qualification':'Qualifications',
        'vivier':'Viviers',
        'listAllVivier':'Viviers',
        'fiche':'Viviers',
        'vivier-rating-temp-worker':'Viviers',
        'admin-console':'Console d\'administration',
        'admin-profil':'Mon profil',
        'payslipManagement':'Paie & Factures',
    }
    return (
        <>
            <header className='sticky z-20 top-0 bg-white border-b border-gray-100 w-full'>
                <div className='px-4 tab:px-4 lg:px-8'>
                    <div className='flex items-center justify-between h-[60px] tab:h-[70px] -mb-px'>
                        {/* Header: Left side - Nom de la page sur tous les écrans */}
                        <div className="flex">
                            <span className='ft-lg text-gray-700'>{PAGE[page]}</span>
                        </div>
                        {/* Header: Right side */}
                        <div className='flex items-center px-2 gap-4'>
                            <MediaQuery minWidth={769}>
                                <NavbarDesktop/>
                            </MediaQuery>
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
};

export default Navbar;